import React from 'react'
import logo from '../printer_svg.svg';

import { Dimmer, Loader, Image, Segment } from 'semantic-ui-react'

export const MainLogo = (
    <Image src={require('../images/printboda_logo.png')} />
)

export const LoadingComponent = () => (
            <div>
                <Segment>
                <Dimmer active>
                    <Loader>Loading</Loader>
                </Dimmer>

                <Image src={require('../images/printboda_logo.png')} />
                </Segment>
            </div>
        )


// WEBPACK FOOTER //
// ./src/config/UiConstants.js